import { useCallback as e, useEffect as t, useRef as n, useState as r } from "react";
//#region src/useCopyToClipboard.ts
function i(i = 1500) {
	let [a, o] = r(!1), s = n(null);
	return t(() => () => {
		s.current && clearTimeout(s.current);
	}, []), {
		copy: e(async (e) => {
			let t = !1;
			try {
				if (typeof navigator < "u" && navigator.clipboard?.writeText) await navigator.clipboard.writeText(e), t = !0;
				else if (typeof document < "u" && typeof document.execCommand == "function") {
					let n = document.createElement("textarea");
					n.value = e, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", document.body.appendChild(n), n.select(), t = document.execCommand("copy"), document.body.removeChild(n);
				}
			} catch {
				t = !1;
			}
			return t && (o(!0), s.current && clearTimeout(s.current), s.current = setTimeout(() => o(!1), i)), t;
		}, [i]),
		copied: a
	};
}
//#endregion
export { i as useCopyToClipboard };
